import React, { useEffect, useState } from 'react';
import '../../App.css';
import './Board.css';
import { useAuth } from '../../contexts/AuthContext.js';
import { useNavigate } from 'react-router-dom';
import { getFirestoreData } from '../../firebase/Firestore.js'
import { BoardData } from './BoardData.js';
import BoardMemberCurr from './BoardMemberCurr.js';
import BoardMember23 from './BoardMember23.js';
import BoardMember22 from './BoardMember22.js';

function toggleDropdown(id, arrow_id) {
    const dropdownContent = document.getElementById(id);
    const arrow = document.getElementById(arrow_id)
    if (dropdownContent.style.display === "contents") {
        dropdownContent.style.display = "none"; 
        arrow.style.transform = "rotate(0deg)";
    } else {
        dropdownContent.style.display = "contents"; 
        arrow.style.transform = "rotate(180deg)";
    }
}


const Board = () => {


    return (
        <div className="board-page">
            <div className="header-container">
                <img
                    src="/images/board-image.JPG"
                    alt="Board Header"
                    className="header-image"
                />  
                <h1 className="board-title">Our Board</h1>
            </div>
            <div className="banner">
                <p style={{ fontWeight: 500 }}>BLing Board 2026-2027</p>
            </div>
            <div className="board-page-container">
                <div className="table-container">
                    <div className="table-container">
                    {BoardData['2026-2027'].members.map(member => (
                        <BoardMemberCurr key={member.id} member={member} />
                    ))}

                    <div className="description"></div> {/* formatting */}
                    <div className="description"></div>
                </div>
                </div>

                <div className="banner">
                    <p style={{ fontWeight: 500 }}>Past Boards</p>
                </div>

                <div className="table-container">
                    <div className="dropdown">

                        <button className="dropdown-button" onClick={() => toggleDropdown("board-2526", "arrow-2526")}>BLing Board 2025-2026  <img src="/images/down-arrow.png" className="arrow" alt="arrow" id="arrow-2526" ></img></button>
                        <div className="dropdown-content" id="board-2526">
                            <div className="table-container">
                                {BoardData['2025-2026'].members.map(member => (
                                    <BoardMemberCurr key={member.id} member={member} />
                                ))}

                                <div className="description" />
                                <div className="description" />
                            </div>
                        </div>
                    </div>

                    <div className="dropdown">

                        <button className="dropdown-button" onClick={() => toggleDropdown("board-2425", "arrow-2425")}>BLing Board 2024-2025 <img src="/images/down-arrow.png" className="arrow" alt="arrow" id="arrow-2425"></img></button>
                        <div className="dropdown-content" id="board-2425">
                            <div className="table-container">
                                {BoardData['2024-2025'].members.map(member => (
                                    <BoardMemberCurr key={member.id} member={member} />
                                ))}

                                <div className="description" />
                                <div className="description" />

                            </div>
                        </div>
                    </div>

                    <div className="dropdown">

                        <button className="dropdown-button" onClick={() => toggleDropdown("board-2324", "arrow-2324")}>BLing Board 2023-2024 <img src="/images/down-arrow.png" className="arrow" alt="arrow" id="arrow-2324"></img></button>
                        <div className="dropdown-content" id="board-2324">
                            <div className="table-container">
                                {BoardData['2023-2024'].members.map(member => (
                                    <BoardMember23 key={member.id} member={member} />
                                ))}

                                <div className="description" />
                                <div className="description" />

                            </div>
                        </div>
                    </div>
                    <div className="dropdown">

                        <button className="dropdown-button" onClick={() => toggleDropdown("board-2223", "arrow-2223")}>BLing Board 2022-2023 <img src="/images/down-arrow.png" className="arrow" alt="arrow" id="arrow-2223"></img></button>
                        <div className="dropdown-content" id="board-2223">
                            <div className="table-container">
                                {BoardData['2022-2023'].members.map(member => (
                                    <BoardMember22 key={member.id} member={member} />
                                ))}

                                <div className="profile-pic-dropdown" />

                            </div>
                        </div>
                    </div>
                </div>

            </div>


        </div>
    );
};

export default Board;